import { steps } from '../../data/homepageData';

export function HowItWorks() {
  return (
    <section id="how-it-works" className="section section--compact">
      <h2>Jak to funguje</h2>
      <div className="steps-grid">
        {steps.map(({ number, icon: Icon, title, text }) => (
          <article className="step-card" key={title}>
            <span className="step-card__number">{number}</span>
            <span className="step-card__icon"><Icon size={22} /></span>
            <h3>{title}</h3>
            <p>{text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
